module.exports = __webpack_public_path__ + "static/assets/32e097cfc94519493e9141415120a01a.gif";